import { Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./pages/Navbar";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Product from "./pages/Product";
import Footer from "./pages/Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element=<Home />></Route>
        <Route path="/about" element=<About />></Route>
        <Route path="/services" element=<Services />></Route>
        <Route path="/contact" element=<Contact />></Route>
        <Route path="/products" element=<Product />></Route>
      </Routes>
      <div className="footer">
        <Footer />
      </div>
    </div>
  );
}

export default App;
